// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  InstantSearch.prototype.init = function () {
    console.log("init");
    var inputElements = jQ(
      'input[name="' +
        Settings.getSettingValue("search.termKey") +
        '"]:not([data-disable-instant-search]):not(.boost-pfs-search-box)'
    );
    inputElements.each((index, inputElement) => {
      var id = "boost-pfs-search-box-" + index;
      var searchBox = new SearchInput(id, jQ(inputElement));
      this.addComponent(searchBox);
    });
    // Build search input for mobile
    if (Utils.isMobile()) {
      // Build Suggestion mobile on top
      if (
        Settings.getSettingValue("search.suggestionMobileStyle") !==
        InstantSearchEnum.Mobile.SuggestionType.STYLE_2
      ) {
        var instantSearchMobile = InstantSearchStyle.instantSearchMobile();
        this.addComponent(instantSearchMobile);
      }
    }
    // Build search input for style3
    if (
      !Utils.isMobile() &&
      Settings.getSettingValue("search.suggestionStyle") === "style3"
    ) {
      var instantSearchStyle3 = InstantSearchStyle.instantSearchStyle3();
      this.addComponent(instantSearchStyle3);
    }
  };

  InstantSearchResult.prototype.init = function () {
    console.log("init InstantSearchResult");
    // Loading block
    this.loadingBlock = new InstantSearchResultBlockLoading();
    this.addComponent(this.loadingBlock);

    // Result block, we need to clone the setting
    this.blockSettings = Settings.getSettingValue("search.suggestionBlocks");

    // Add on click blocks to block setting
    this.onClickBlocks = InstantSearchOnclick.getOnClickBlockSettings();
    this.blockSettings = this.onClickBlocks.concat(this.blockSettings);

    // Add no result blocks to block setting
    this.noResultBlocks = InstantSearchNoResult.getNoResultBlockSettings();
    this.blockSettings = this.blockSettings.concat(this.noResultBlocks);

    // Put the Product block to top for Style2
    this._applyFilterBlockSettings();

    this.blockSettings.forEach((blockSetting) => {
      var block = new InstantSearchResultBlock(blockSetting);
      this.addComponent(block);
      this.blocks.push(block);
    });

    // View all block
    var blockViewAll = new InstantSearchResultBlockViewAll();
    this.addComponent(blockViewAll);
    this.blockViewAll = blockViewAll;

    // Empty block
    var blockEmpty = new InstantSearchResultBlockEmpty();
    this.addComponent(blockEmpty);
    this.blockEmpty = blockEmpty;

    // Init static block data
    InstantSearchNoResult.getNoResultData();
    InstantSearchOnclick.getOnClickData();
  };

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {
      var searchTerm = Utils.stripHtml(Globals.currentTerm);
      // Product image
      var imageHTML = "";
      if (
        Settings.getSettingValue("search.showSuggestionProductImage") &&
        this.imageUrl.length
      ) {
        imageHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.IMAGE
        );
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
      }
      // Product title
      var productTitle = this.customizeProductTitle();
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      // SKU
      var skuHTML = "";
      if (
        Settings.getSettingValue("search.showSuggestionProductSku") &&
        this.sku.length
      ) {
        skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
        skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
      }
      // Vendor
      var vendorHTML = "";
      if (
        Settings.getSettingValue("search.showSuggestionProductVendor") &&
        this.vendor.length
      ) {
        vendorHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.VENDOR
        );
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
      }
      // Price
      console.log(this.data);
      console.log("test", this.data.tags.indexOf("hide-price"));
      var priceHTML;
      if (this.data.tags.includes("hide-price")) {
        priceHTML = "";
      } else {
        priceHTML = this.compileSuggestionProductPrice();
      }

      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue("search.openProductNewTab")
        ? 'target="_blank"'
        : "";

      return this.getTemplate()
        .replace(/{{id}}/g, this.id)
        .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
        .replace(/{{url}}/g, this.url)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
        .replace(/{{itemProductSku}}/g, skuHTML)
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(
          /{{class.searchUiAutocompleteItem}}/g,
          Class.searchUiAutocompleteItem
        );
    } else {
      return "";
    }
  };
})();
